import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Form } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { TextInputForm, LoadingSpinner } from "../components/Forms";
import { PageHead, PageTitle } from "../components/PageTitle";
import { VscEyeClosed, VscEye } from "react-icons/vsc";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../config/config";

const ProductHistory = ["S.No", "Name", "MobileNumber", "Action"];

const User = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({
    Parties: false,
    Items: false,
    // Onlinebills: false,
    Purchase: false,
    Sales: false,
    Expense: false,
    Report: false,
  });

  const handleClose = () => {
    setShow(false);
    setCrtUser(null);
    setFormData({
      name: "",
      phone_number: "",
      password: "",
      user_type: "",
      staff_permission: "",
    });
    setPermissions({
      Parties: false,
      Items: false,
      // Onlinebills: false,
      Purchase: false,
      Sales: false,
      Expense: false,
      Report: false,
    });
    location.state = [];
  };

  const handleShow = () => {
    setCrtUser(null);
    setFormData({
      name: "",
      phone_number: "",
      password: "",
      user_type: "",
      staff_permission: "",
    });
    setPermissions({
      Parties: false,
      Items: false,
      // Onlinebills: false,
      Purchase: false,
      Sales: false,
      Expense: false,
      Report: false,
    });
    setShow(true);
  };

  const [showPassword, setShowPassword] = useState(false);
  const [crtuser, setCrtUser] = useState(null);

  const handleEditClick = (rowdata) => {
    setCrtUser(rowdata);
    if (rowdata.staff_permission) {
      const perms = rowdata.staff_permission
        .replace(/[{}]/g, "")
        .split(",")
        .filter((p) => p);
      setPermissions({
        Parties: perms.includes("Parties"),
        Items: perms.includes("Items"),
        // Onlinebills: perms.includes("Onlinebills"),
        Purchase: perms.includes("Purchase"),
        Sales: perms.includes("Sales"),
        Expense: perms.includes("Expense"),
        Report: perms.includes("Report"),
      });
    } else {
      setPermissions({
        Parties: false,
        Items: false,
        // Onlinebills: false,
        Purchase: false,
        Sales: false,
        Expense: false,
        Report: false,
      });
    }
    setShow(true);
  };

  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    password: "",
    user_type: "",
    staff_permission: "",
  });

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;

    if (crtuser != null) {
      setCrtUser((prev) => {
        const updatedUser = {
          ...prev,
          [fieldName]: value,
        };
        if (fieldName === "user_type" && value === "admin") {
          updatedUser.staff_permission = "";
          setPermissions({
            Parties: false,
            Items: false,
            // Onlinebills: false,
            Purchase: false,
            Sales: false,
            Expense: false,
            Report: false,
          });
        }
        return updatedUser;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: value,
        ...(fieldName === "user_type" && value === "admin"
          ? { staff_permission: "" }
          : {}),
      }));
      if (fieldName === "user_type" && value === "admin") {
        setPermissions({
          Parties: false,
          Items: false,
          // Onlinebills: false,
          Purchase: false,
          Sales: false,
          Expense: false,
          Report: false,
        });
      }
    }
  };

  const handlePermissionChange = (e) => {
    const { name, checked } = e.target;
    setPermissions((prev) => ({
      ...prev,
      [name]: checked,
    }));
    const selectedPermissions = Object.keys(permissions)
      .filter((key) => (key === name ? checked : permissions[key]))
      .join(",");
    const formattedPermissions = selectedPermissions
      ? `{${selectedPermissions}}`
      : "";
    if (crtuser != null) {
      setCrtUser((prev) => ({
        ...prev,
        staff_permission: formattedPermissions,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        staff_permission: formattedPermissions,
      }));
    }
  };

  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/user.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      const responseData = await response.json();
         setLoading(false);
      if (responseData.head.code === 200) {
        setUserData(responseData.body.user);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      errorAlert(`Failed to load users: ${error.message}`);
      console.error("Fetch Data Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    try {
      if (
        formData.name === "" ||
        formData.phone_number === "" ||
        formData.password === ""
      ) {
        if (formData.name === "") {
          errorAlert("Name is required");
        } else if (formData.phone_number === "") {
          errorAlert("Mobile Number is required");
        } else if (formData.password === "") {
          errorAlert("Password is required");
        }
      } else {
        const response = await fetch(`${API_DOMAIN}/user.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const responseData = await response.json();

        if (responseData.head.code === 200) {
          setFormData({
            name: "",
            phone_number: "",
            password: "",
            user_type: "",
            staff_permission: "",
          });
          setPermissions({
            Parties: false,
            Items: false,
            // Onlinebills: false,
            Purchase: false,
            Sales: false,
            Expense: false,
            Report: false,
          });
          successAlert(responseData.head.msg);
          setTimeout(() => {
            fetchData();
            handleClose();
            window.location.reload();
          }, 2000);
        } else if (responseData.head.code === 400) {
          errorAlert(responseData.head.msg);
        }
      }
    } catch (error) {
      errorAlert("An error occurred while submitting");
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/user.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: crtuser.user_id,
          name: crtuser.name,
          phone_number: crtuser.phone_number,
          password: crtuser.password,
          user_type: crtuser.user_type,
          staff_permission: crtuser.staff_permission,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update user");
      }

      const responseData = await response.json();

      if (responseData.head.code === 200) {
         successAlert(responseData.head.msg);
        setTimeout(() => {
            fetchData();
            handleClose();
            window.location.reload();
          }, 2000);
      } else {
        errorAlert(responseData.head.msg || "Failed to update user");
      }
    } catch (error) {
      errorAlert("An error occurred while updating");
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading User&Access..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="py-3">
        <div className="main">
          <Row className="mx-2">
            <Col lg="7" md="6" xs="12" className="align-self-center">
              <PageTitle PageTitle={"User"} />
            </Col>
            <Col lg="5" md="6" xs="12">
              <div className="text-end py-3">
                <Buttons lable={<>Add New</>} onClick={handleShow} />
              </div>
            </Col>
            <Col lg={12} md={12} xs={12} className="py-2">
              <div className="py-2 c-table">
                <TableUI
                  headers={ProductHistory}
                  body={userData}
                  type="USER"
                  handleEditClick={handleEditClick}
                  onDelete={fetchData}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Main Modal for User Creation/Update */}
      <Modal show={show} onHide={handleClose} size="xl" centered scrollable>
        <Modal.Header>
          <Modal.Title>
            <PageHead
              pagehead={`User${crtuser != null ? " Update" : " Creation"}`}
              onClick={handleClose}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row>
              <Col lg="4" md="6" xs="12" className="py-3">
                <TextInputForm
                  labelname={"Name"}
                  placeholder={"Name"}
                  name="name"
                  value={crtuser != null ? crtuser.name : formData.name}
                  onChange={(e) => handleChange(e, "name")}
                />
              </Col>
              <Col lg="4" md="6" xs="12" className="py-3">
                <TextInputForm
                  labelname={"MobileNumber"}
                  placeholder={"MobileNumber"}
                  type={"tel"}
                  name="phone_number"
                  value={
                    crtuser != null
                      ? crtuser.phone_number
                      : formData.phone_number
                  }
                  onChange={(e) => handleChange(e, "phone_number")}
                />
              </Col>
              <Col lg="4" md="6" xs="12" className="py-3">
                <TextInputForm
                  placeholder={"Password"}
                  labelname={"Password"}
                  suffix_icon={
                    showPassword ? (
                      <VscEye onClick={() => setShowPassword(false)} />
                    ) : (
                      <VscEyeClosed onClick={() => setShowPassword(true)} />
                    )
                  }
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={crtuser != null ? crtuser.password : formData.password}
                  onChange={(e) => handleChange(e, "password")}
                />
              </Col>
              <Col lg="12" md="12" xs="12" className="py-3">
                <Form.Group>
                  <Form.Label>User Type</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Admin"
                      type="radio"
                      name="user_type"
                      value="admin"
                      checked={
                        crtuser != null
                          ? crtuser.user_type === "admin"
                          : formData.user_type === "admin"
                      }
                      onChange={(e) => handleChange(e, "user_type")}
                    />
                    <Form.Check
                      inline
                      label="Staff"
                      type="radio"
                      name="user_type"
                      value="staff"
                      checked={
                        crtuser != null
                          ? crtuser.user_type === "staff"
                          : formData.user_type === "staff"
                      }
                      onChange={(e) => handleChange(e, "user_type")}
                    />
                  </div>
                </Form.Group>
              </Col>
              {(crtuser != null ? crtuser.user_type : formData.user_type) ===
                "staff" && (
                <Col lg="12" md="12" xs="12" className="py-3">
                  <Form.Group>
                    <Form.Label>Staff Permissions</Form.Label>
                    <div>
                      {[
                        "Parties",
                        "Items",
                        // "Onlinebills",
                        "Purchase",
                        "Sales",
                        "Expense",
                        "Report",
                      ].map((perm) => (
                        <Form.Check
                          key={perm}
                          inline
                          type="checkbox"
                          label={perm.charAt(0).toUpperCase() + perm.slice(1)}
                          name={perm}
                          checked={permissions[perm]}
                          onChange={handlePermissionChange}
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Col>
              )}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Col lg="12" md="12" xs="12" className=" align-self-center">
            <div className="text-center">
              <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              {crtuser != null ? (
                <>
                  <span className="mx-2">
                    <ClickButton
                      label={<>Update</>}
                      onClick={handleUpdateSubmit}
                    />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              ) : (
                <>
                  <span className="mx-2">
                    <ClickButton label={<>Submit</>} onClick={handleSubmit} />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              )}
            </div>
          </Col>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default User;

